import API from "../API Service/ApiCalls";
import ApiService from "../API Service/ApiService";
import { appConstants } from "../Pages/AppConstants";

var apiService = new ApiService();

class WorkflowTemplateServiceController {
  getEachTabToolTipDetail = async () => {
    var response = await apiService.getData(API.toolTipDetails, {});
    var json = await response.json();
    return json;
  };

  getWorkflowTemplateList = async () => {
    var response = await apiService.getData(API.workflowTemplateAPI, { "clientId": appConstants.clientId });
    var json = await response.json();
    return json;
  };
  removeDataOnWorkflowTemplateList = async (id) => {
    var response = await apiService.postData(API.removeDatafromWorkflowTemplate, { 'id': id });
    return response;
  };
  publishWorkflowTemplate = async (id, mode) => {
    var response = await apiService.postData(API.publishWorkflowTemplate, { "id": id, "mode": mode });
    return response;
  };
  getWorkflowTemplateDropdownValuesClient = async () => {
    var response = await apiService.getData(API.clientDropdownValues, {});
    var json = await response.json();
    return json;
  };
  getWorkflowTemplateDropdownValuesDept = async (id) => {
    var response = await apiService.getData(API.departmentDropdownValues, { });
    if (response === null) {
    }
    else {
      var json = await response.json();
      // return json;
      if (json.length != 0) {
        return json;
      }
      else {
        return [
          {
            name: "--select--",
            id: "0",
          },
        ];
      }
    }
  }

  getWorkflowTemplateFilterDropdownValues = async (id) => {
    var response = await apiService.getData(API.filterDropdownValues, { "clientId": id });
    if (response === null) {
      return response;

    }
    else {
      var json = await response.json();
      return json;
    }
  }

  getSidebarComponents = async () => {
    var response = await apiService.getData(API.sidebarComponents, { "clientId": appConstants.clientId });
    if (response === null) {
      return response;
    }
    else {
      var json = await response.json();
      return json;
    }
  }

  getEventTypes = async () => {
    var response = await apiService.getData(API.getRecruitmentEventTypes,{});
    if (response === null) {
      return response;
    }
    else {
      var json = await response.json();
      return json;
    }
  }

  addEditWorkflowTemplate = async (requestBody) => {
    var response = await apiService.postData(API.addEditWorkflowTemplate, {}, requestBody);
    return response;
  };

  getPreviewImg = async (id) => {
    var response = await apiService.getData(API.previewImage, { "id": id });
    return response.text();
  }
  getConsolidatedWorkflow = async (id) => {
    var response = await apiService.getData(API.consolidatedJson, { "id": id });
    return response.text();
  };

  getworkflowMappingJobDropdownValues = async (mode) => {
    var response = await apiService.getData(API.workflowMappingJobDropdownValues, { 'mode': mode });
    var json = await response.json();
    return json;
  };

  getworkflowMappingDropdownValues = async (id) => {
    const response = await apiService.getData(API.workflowMappingDropdownValues, { "jobId": id });
    var json = await response.json();
    return json;  // ✅ return only JSON
  };
  postworkflowMappingInstance = async (requestBody) => {
    const response = await apiService.postData(API.workflowAddWorkflowInstance, {}, requestBody);
    //var json = await response.json();
    return response;  // ✅ return only JSON
  };

  getworkflowGetAllInstance = async () => {
    var response = await apiService.getData(API.workflowGetAllInstance, {});
    var json = await response.json();
    return json;
  };

  postworkflowDeleteWorkflowInstance = async (id) => {
    var response = await apiService.postData(API.workflowDeleteWorkflowInstance, { 'id': id });
    return response;
  };

  postworkflowCloneWorkflowInstance = async (id) => {
    var response = await apiService.postData(API.workflowCloneWorkflowInstance, { 'id': id });
    return response;
  };

  getWorkflowInstanceById = async (id) => {
    var response = await apiService.getData(API.getWorkflowInstanceById, { "id": id });
    var json = await response.json();
    return json;
  }

  getNotesByTemplateId = async (id) => {
    var response = await apiService.getData(API.getNotesByTemplateId, { "templateId": id });
    return response;
  }

  getNodeDataByTemplateId = async (workflowId, skillLevel, versionId) => {
    var response = await apiService.getData(API.getNodeDataByTemplateId, { "workflowId": workflowId, "skillLevel": skillLevel, "versionId": versionId });
    var json = await response.json();
    return json;
  }

  getEventTypedropdown = async () => {
    var response = await apiService.getData(API.getEventTypedropdown, {});
    if (response === null) {
      return response;
    }
    else {
      var json = await response.json();
      return json;
    }
  }
  getGetApiEndPointdropdown = async () => {
    var response = await apiService.getData(API.getGetApiEndPointdropdown, {});
    if (response === null) {
      return response;
    }
    else {
      var json = await response.json();
      return json;
    }
  }
  getAllRoles = async () => {
    var response = await apiService.getData(API.getAllRoles, {});
    if (response === null) {
      return response;
    }
    else {
      var json = await response.json();
      return json;
    }
  }

  getWorkFlowPermissionById = async (workflowId, workflowType, levelId) => {
    var response = await apiService.getData(API.getWorkFlowPermissionById, { "workflowId": workflowId, "workflowType": workflowType, "levelId": levelId });
    if (response === null) {
      return response;
    }
    else {
      var json = await response.json();
      return json;
    }
  }
    getCompletionRulesByWorkflowId = async (workflowId, levelId) => {
    var response = await apiService.getData(API.getCompletionRulesByWorkflowId, { "workflowId": workflowId, "levelId": levelId });
    if (response === null) {
      return response;
    }
    else {
      var json = await response.json();
      return json;
    }
  }

   postAddUpdateWorkFlowPermission = async (requestBody) => {
    const response = await apiService.postData(API.postAddUpdateWorkFlowPermission, {}, requestBody);
    return response;  // ✅ return only JSON
  };
    postAddUpdateWFCompletionRule = async (requestBody) => {
    const response = await apiService.postData(API.postAddUpdateWFCompletionRule, {}, requestBody);
    return response;  // ✅ return only JSON
  };

  getWorkflowTemplateDropdownValuesVersion = async (id) => {
    var response = await apiService.getData(API.getDropdownVersionValues, { "templateId": id });
    if (response === null) {
    }
    else {
      var json = await response.json(); 
      // return json;
      if (json.length != 0) {
        return json;
      }
      else {
        return null;
      }
    }
  }
   getVersionTemplateByTemplateId = async (templateId, version) => {
    var response = await apiService.getData(API.getVersionTemplateByTemplateId, { "templateId": templateId, "version": version });
    if (response === null) {
      return response;
    }
    else {
      var json = await response.json();
      return json;
    }
  }
  getDefaultTemplates = async () => {
    var response = await apiService.getData(API.getDefaultTemplates, { });   
    if (response === null || response.Success === false) {
      return response;
    }
    else {
      var json = await response.json();
      return json;
    }
  }
  getSelectedDefaultTemplateId = async (defaultId) => {
    var response = await apiService.getData(API.getSelectedDefaultTemplateId, { "Id": defaultId });
    if (response === null || response.Success === false) {
      return response;
    }
    else {
      var json = await response.json();
      return json;
    }
  }

   postAddWorkflowNote = async (workflowTemplateId, note) => {
    const response = await apiService.postData(API.postAddWorkflowNote, { "workflowTemplateId" : workflowTemplateId, "note" : note });
    return response;  // ✅ return only JSON
  };
}
export default WorkflowTemplateServiceController; 
